import { hasPropertyCheck } from './hasPropertyCheck';

export const removeDuplicatedObjectsByKey = (array, key) => {
  const unique = [];

  array.forEach(object => {
    return unique.filter(filteredObject => {
      if (hasPropertyCheck(object, key) && hasPropertyCheck(filteredObject, key)) {
        return filteredObject[key] === object[key];
      }
    }).length > 0
      ? null
      : unique.push(object);
  });

  return unique;
};
